import React from 'react';
import { WrapperS, MessageWrapperS } from './styles';

interface ErrorProps {
  message?: string
}

export const ErrorPage: React.FC<ErrorProps> = ({message}) => {
  return (
    <WrapperS>
      <MessageWrapperS dangerouslySetInnerHTML={{ __html: message ? message : '' }}/>
    </WrapperS>
  );
};
